import "./index.css";
import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";

const ZALO_SUPPORT_GROUP_URL = process.env.REACT_APP_ZALO_SUPPORT_GROUP_URL;

function SupportGroupCard({ url = ZALO_SUPPORT_GROUP_URL }) {
  // Chỉ có tác dụng ở mobile; desktop luôn hiển thị card
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="support-group-toggle"
        aria-label="Nhóm hỗ trợ kĩ thuật"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        {open ? (
          <span className="support-group-toggle__close">&times;</span>
        ) : (
          <svg viewBox="0 0 52 52" width="52" height="52" aria-hidden="true">
            <defs>
              <linearGradient id="zaloBg" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#2aa8ff" />
                <stop offset="1" stopColor="#0068ff" />
              </linearGradient>
            </defs>
            <rect width="52" height="52" rx="14" fill="url(#zaloBg)" />
            <path
              d="M26 10C16.6 10 9 16.5 9 24.6c0 4.4 2.2 8.3 5.7 11-.3 2.2-1.2 4.2-2.7 5.9 3.2-.2 6-1.4 8.1-3.1 1.7.5 3.4.7 5.2.7 9.4 0 17-6.5 17-14.5S35.4 10 26 10z"
              fill="#fff"
            />
            <text
              x="26"
              y="29"
              textAnchor="middle"
              fontSize="12.5"
              fontWeight="800"
              fill="#0068ff"
              fontFamily="Arial, sans-serif"
            >
              Zalo
            </text>
          </svg>
        )}
      </button>

      <aside
        className={`support-group-card${
          open ? " support-group-card--open" : ""
        }`}
        aria-label="Nhóm hỗ trợ kĩ thuật"
      >
        <p className="support-group-card__title">Nhóm hỗ trợ kĩ thuật</p>
        <a
          className="support-group-card__btn"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          Vào nhóm
        </a>
        <div className="support-group-card__qr">
          <QRCodeSVG
            value={url}
            size={156}
            level="M"
            bgColor="#ffffff"
            fgColor="#1a1208"
          />
        </div>
      </aside>
    </>
  );
}

export default SupportGroupCard;
